import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ChainsThemeProvider } from './context/ChainsThemeContext';
import ChainsLayout from './components/layout/ChainsLayout';
import ChainsDashboard from './components/dashboard/ChainsDashboard';
import PurchaseRequests from './components/purchase-requests/PurchaseRequests';
import Procurement from './components/procurement/Procurement';
import Logistics from './components/logistics/Logistics';
import Warehouse from './components/warehouse/Warehouse';
import Planning from './components/planning/Planning';
import Reports from './components/reports/Reports';
import ChainsSettings from './components/settings/Settings';

const Chains = () => {
  return (
    <ChainsThemeProvider>
      <ChainsLayout />
    </ChainsThemeProvider>
  );
};

export default Chains; 